import { render, staticRenderFns } from "./MedicalVisit.vue?vue&type=template&id=5b72c3c0&scoped=true&"
import script from "./MedicalVisit.vue?vue&type=script&lang=js&"
export * from "./MedicalVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b72c3c0",
  null
  
)

export default component.exports